import clsx from 'clsx';
import MenuGroup from './MenuGroup';

import { CUSTOMER_EXPERIENCE } from '../fixtures/links';

import '../styles/Menu.scss';

import apple from '@/assets/images/apple.png';
import google from '@/assets/images/google_play.png';

const Menu = ({ isOpen, close }) => {
  const menuClassNames = clsx(
    'dropdown-menu',
    'menu',
    isOpen ? '-shown' : '-hidden'
  );

  return (
    <nav className={menuClassNames}>
      <MenuGroup links={CUSTOMER_EXPERIENCE} onClick={close} title='Customer Experience Center' />
      <div className='contact'>
        <p>Contact us at <span>cx@synthnode.io</span></p>
        <br />
        {/* <p>Telephone: <span>+1 415-850-3040</span></p>
        <br /> */}
        <p>San Francisco California USA</p>
      </div>
      <div className='app-icons-container flex'>
        <a href='https://play.google.com/store/apps/details?id=io.synthnode_app' target='_blank'>
          <img src={google} />
        </a>
        <a href='https://apps.apple.com/ca/app/synthnode/id6761746074' target='_blank'>
          <img src={apple} />
        </a>
      </div>
    </nav >
  );
};

export default Menu;
